module.exports = __webpack_public_path__ + "img/wheel.63e0894c.png";